import { IProjectElementDetailsOutput } from "./ProjectElementsModel";

export interface ITransmittalTemplateModel {
    project_Id: number;
    group_Id: number;
    template_Id?: number|null;
    template_Name: string;
    template_Remarks?: string;
    template_Subject: string;
    quantity?: number;
    category?: number;
    is_Active: boolean;
    userId: number;
}

export interface ITransmittalReceiverDetails {
    template_Id: number;
    receiverFromDetails: IReceiverDetails[];
    receiverToDetails: IReceiverDetails[];
    receiverCcDetails: IReceiverDetails[];
    is_Active: boolean;
    userId: number;
}

export interface IReceiverDetails {
    member_Id: number;
    receiver_Type: number;
    receiver_Group?: number|null;
    sort_By?: number;
    member_Name?: string;
}

export interface ITransmittalGroupViewModel {
    receiver_Group: number | null | undefined;
    members: ITransmittalMemberModel[];
    quantity?: number;
    category: IProjectElementDetailsOutput;
    type?: IProjectElementDetailsOutput[];
    remarks: string;
}

export interface ITransmittalMemberModel {
    eMailId: string;
    memberId: number;
    memberName?: string;
    memberShortName?: string;
    mobileNo: string;
    staffPSNo: string;
    groupBy?: number|null|undefined;
    groupName?: string;
    address?: string;
}

export interface ITransmittalDistributionModel {
    project_Id : number;
    template_Id : number;
    DistributionGroupDetails: IDistributionDetails[];
    is_Active: boolean;
    userId: number;
}

export interface IDistributionDetails{
    receiver_Group: number;
    quantity: number;
    category: number;
    copy_Type: number;
    remarks: string;
}
export interface ITransmittalInputModel {
    project_Id : number | undefined;
    group_Id : number | undefined;
    template_Id?: string | number | null;
}

export interface ITransmittalInputDetailModel {
    template_Id: string | number | null;
}

export interface ITransmittalDistributionViewModel {
    member_Name : string;
    receiver_Group : number;
    category: number;
    copy_Type: number;
    quantity: number;
    remarks: string;
    category_Description: string;
    category_Short_Description: string;
    type_Description: string;
    type_Short_Description: string;
}